import { Modal, Form, DatePicker } from "antd"
import { FC, useEffect } from "react"
import { SubmitCancelButtons } from "components"
import { createContestPeriod, updateContestPeriod, CreateContestPeriodRequest, ContestPeriod } from "../../../api"
import { notification } from "antd"
import moment from "moment"

interface PeriodModalProps {
  visible: boolean;
  onClose: () => void;
  editType: "create" | "edit";
  contestName: string;
  editingPeriod?: ContestPeriod | null;
  loading: boolean;
  onSuccess: () => void;
}

export const PeriodModal: FC<PeriodModalProps> = ({
  visible,
  onClose,
  editType,
  contestName,
  editingPeriod,
  loading,
  onSuccess,
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (editType === "edit" && editingPeriod && visible) {
      form.setFieldsValue({
        startsAt: moment(editingPeriod.startsAt),
        endsAt: moment(editingPeriod.endsAt),
      })
    }
  }, [editType, editingPeriod, visible, form])

  const handleSubmit = async(values: { startsAt: moment.Moment; endsAt: moment.Moment }) => {
    try {
      const requestData: CreateContestPeriodRequest = {
        startsAt: values.startsAt.toISOString(),
        endsAt: values.endsAt.toISOString(),
      }

      if (editType === "create") {
        await createContestPeriod(contestName, requestData)
        notification.success({ message: "Contest period created successfully" })
      } else {
        if (!editingPeriod) return
        await updateContestPeriod(editingPeriod.id, requestData)
        notification.success({ message: "Contest period updated successfully" })
      }

      onClose()
      form.resetFields()
      onSuccess()
    } catch (error) {
      console.error(`Failed to ${editType} contest period:`, error)
      notification.error({ message: `Failed to ${editType} contest period` })
    }
  }

  const handleClose = () => {
    onClose()
    form.resetFields()
  }

  return (
    <Modal
      visible={visible}
      title={editType === "create" ? "Create new period" : "Edit period"}
      width="500px"
      footer={null}
      onCancel={handleClose}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="vertical"
      >
        <Form.Item
          label="Start Date"
          name="startsAt"
          rules={[{ required: true, message: "Please select start date" }]}
        >
          <DatePicker
            showTime
            style={{ width: "100%" }}
            placeholder="Select start date"
          />
        </Form.Item>

        <Form.Item
          label="End Date"
          name="endsAt"
          rules={[{ required: true, message: "Please select end date" }]}
        >
          <DatePicker
            showTime
            style={{ width: "100%" }}
            placeholder="Select end date"
          />
        </Form.Item>

        <SubmitCancelButtons
          onClose={handleClose}
          isLoading={loading}
        />
      </Form>
    </Modal>
  )
}
